module.exports = __webpack_public_path__ + "img/developers--icon.c6cb1d66.svg";